module.exports = {"530122001":"昆阳街道","530122102":"晋城镇","530122103":"二街镇","530122105":"上蒜镇","530122106":"六街镇","530122201":"双河彝族乡","530122202":"夕阳彝族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/530122.json
// module id = 2545
// module chunks = 0